import { jsx as _jsx } from "react/jsx-runtime";
/*
 * Link styling, for a folder that cannot reach the host stylesheet.
 *
 * The underline sits at about a third strength and firms up under the pointer:
 * present enough to mark the link at a glance, quiet enough not to cut through
 * a paragraph, and it still answers "is this the thing I am about to click".
 *
 * Shipped as a style tag rather than a class the host defines, for the same
 * reason the typing animation is. A class name that lives in someone else's CSS
 * is a dependency this folder is not allowed to have, and the failure when the
 * copy lands in another app is silent: the link simply stops looking like one.
 *
 * The colour is declared twice on purpose. Browsers without color-mix ignore
 * the second line and keep the first, which is a solid underline. Weaker as a
 * design, still completely correct as an affordance.
 */

export const LINK = 'graci-link';
const STYLE = `
.${'graci-link'} {
    text-decoration: underline;
    text-decoration-color: currentColor;
    text-decoration-color: color-mix(in srgb, currentColor 32%, transparent);
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;
    transition: text-decoration-color 0.2s ease;
}
.${'graci-link'}:hover,
.${'graci-link'}:focus-visible {
    text-decoration-color: currentColor;
}`;
export const LinkStyles = () => /*#__PURE__*/_jsx("style", {
  children: STYLE
});
const Link = {
  LINK,
  LinkStyles
};
export default Link;